import React from 'react'

import { usePreviewSource } from './use-preview-source'
import { ConfirmationPage } from '../user/confirmation'

export default () => {
  const data = usePreviewSource()
  if (!data) return null
  return <ConfirmationPage form={data.form} />
}
